import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "tag-list-editor";

const keys = addTranslations(RESOURCE_NAME, {
    add_new_label: {
        en: "New tag",
        fr: "Nouveau tag",
    },
    add_new_label_QUESTIONNAIRE: {
        en: "New questionnaire",
        fr: "Nouveau questionnaire",
    },
});

export function useTagListEditorTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
